import React from 'react'
import injectSheet from 'react-jss'
import styles from './preview-item.styles'
import classNames from 'classnames'

const PreviewItem = ({
  classes,
  className,
  image,
  onClick,
  id,
  author,
  userProfileUrl
}) => (
  <div className={classNames(classes.container, className)}>
    <div
      onClick={() => onClick(id)}
      className={classes.holder}
      style={{ backgroundImage: `url(${image})` }}>
      <div className={classes.author}>
        <a
          onClick={e => e.stopPropagation()}
          className={classes.authorLink}
          href={`${userProfileUrl}?utm_source=pobble&utm_medium=referral`}
          target="_blank"
          rel="noopener noreferrer">
          Photo by {author}
        </a>
      </div>
    </div>
  </div>
)

export default injectSheet(styles)(PreviewItem)
